<template>
  <router-view class="register"/>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'clearTemporaryAccessData',
    ]),
  },
  beforeRouteLeave(from, to, next) {
    this.clearTemporaryAccessData();
    next();
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.register
  max-width: 350px
  +media-min-sm()
    max-width: none
  +media-min-md()
  +media-min-lg()
</style>
